const uppercasePattern = /[A-Z]/g,
  msPattern = /^ms-/,
  cache = {};
function toHyphenLower(match) {
  return "-" + match.toLowerCase();
}
function hyphenateStyleName(name) {
  if (name in cache) return cache[name];
  const hName = name.replace(uppercasePattern, toHyphenLower);
  return cache[name] = msPattern.test(hName) ? "-" + hName : hName;
}
var hyphenateStyleName_default = hyphenateStyleName;
export { hyphenateStyleName_default as default };
//# sourceMappingURL=hyphenateStyleName.mjs.map
